import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


function Search() {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [sortOption, setSortOption] = useState("name_asc");
    const [selectedItem, setSelectedItem] = useState(null); // item clicked
    const [sellQuantity, setSellQuantity] = useState(1);
    const [sellPrice, setSellPrice] = useState("");
    const [sellNotes, setsellNotes] = useState("");
    const itemsPerPage = 10;

  // Fetch inventory
  const fetchInventory = async () => {
    const match = document.cookie.match(new RegExp("(^| )token=([^;]+)"));
    try {
        const response = await fetch("https://liquidationapi.dallasagsmith.workers.dev/inventory", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: match[2] }),
        });

        if (response.status === 200) {
        const data = await response.json();
        
        // Group by title/desc/cost/date_added but keep rowids
        const mergedItemsMap = {};
        data.forEach((item) => {
            const key = `${item.title}||${item.description || ""}||${item.cost || 0}||${item.date_added}`;
            if (mergedItemsMap[key]) {
            mergedItemsMap[key].quantity += 1;
            mergedItemsMap[key].rowids.push(item.rowid);
            } else {
            mergedItemsMap[key] = { ...item, quantity: 1, rowids: [item.rowid] };
            }
        });
        setItems(Object.values(mergedItemsMap));
        }
    } catch (error) {
        console.error("Error fetching inventory:", error);
    }
    };


  useEffect(() => {
    fetchInventory();
  }, []);

  // Filter and sort
  const filteredItems = items.filter(
    (item) =>
      item.title.toLowerCase().includes(search.toLowerCase()) ||
      (item.description && item.description.toLowerCase().includes(search.toLowerCase()))
  );

  const sortedItems = [...filteredItems].sort((a, b) => {
    switch (sortOption) {
      case "name_asc": return a.title.localeCompare(b.title);
      case "name_desc": return b.title.localeCompare(a.title);
      case "cost_asc": return (a.cost || 0) - (b.cost || 0);
      case "cost_desc": return (b.cost || 0) - (a.cost || 0);
      case "date_asc": return new Date(a.date_added) - new Date(b.date_added);
      case "date_desc": return new Date(b.date_added) - new Date(a.date_added);
      default: return 0;
    }
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedItems.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedItems.length / itemsPerPage);

  // Handle selling
  const handleSell = async () => {
    if (!sellPrice || sellQuantity < 1) return;

    const match = document.cookie.match(new RegExp("(^| )token=([^;]+)"));

    try {
        console.log(JSON.stringify({
          token: match[2],
          item: selectedItem,
          quantity: sellQuantity,
          notes: sellNotes,
          price: parseFloat(sellPrice)
        }));

      const response = await fetch("https://liquidationapi.dallasagsmith.workers.dev/sell", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: match[2],
          item: selectedItem,
          quantity: sellQuantity,
          notes: sellNotes,
          price: parseFloat(sellPrice)
        }),
      });

      if (response.status === 200) {
        setSelectedItem(null);
        setSellPrice("");
        setSellQuantity(1);
        fetchInventory();
      }
    } catch (error) {
      console.error("Error selling item:", error);
    }
  };

  return (
    <div className="page-container">
      <h2>Inventory</h2>

      {/* Search + Sort */}
      <div className="card" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <input
          type="text"
          placeholder="Search inventory..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          style={{ flex: 1 }}
        />
        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          style={{ padding: "10px", borderRadius: "6px" }}
        >
          <option value="name_asc">Name ↑</option>
          <option value="name_desc">Name ↓</option>
          <option value="cost_asc">Cost ↑</option>
          <option value="cost_desc">Cost ↓</option>
          <option value="date_asc">Date ↑</option>
          <option value="date_desc">Date ↓</option>
        </select>
      </div>

      {/* Inventory list */}
      <div className="transaction-list">
        {currentItems.length === 0 ? (
          <div className="spinner"></div>
        ) : (
          currentItems.map((item, index) => (
            <div className="transaction-card" key={index} onClick={() => setSelectedItem(item)} style={{ cursor: "pointer" }}>
              <div className="transaction-info">
                <div className="transaction-title">
                  {item.title} {item.quantity > 1 && `x${item.quantity}`}
                </div>
                <div className="transaction-desc">{item.description}</div>
              </div>
              <div className="transaction-amounts">
                <div className="transaction-cost">{item.date_added}</div>
                <div className="transaction-sell">Cost: ${Number(item.cost || 0).toFixed(2)}{item.quantity > 1 && ' (per item)'}</div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", gap: "10px" }}>
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}

      {/* Modal Popup */}
        {selectedItem && (
        <div
            style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
            }}
            onClick={() => setSelectedItem(null)} // close on background click
        >
            <div
            className="card"
            style={{ padding: "20px", minWidth: "300px" }}
            onClick={(e) => e.stopPropagation()} // prevent modal click from closing
            >
            <h3>{selectedItem.title}</h3>
            <p>{selectedItem.description}</p>
            <p>Date Added: {selectedItem.date_added}</p>
            <p>Cost: ${Number(selectedItem.cost || 0).toFixed(2)}</p>

            {/* Quantity Input */}
            {selectedItem.quantity > 1 && (
                <div style={{ marginBottom: "10px" }}>
                <label htmlFor="sellQuantity" style={{ fontWeight: "bold", display: "block" }}>
                    Quantity to Sell (Max: {selectedItem.quantity})
                </label>
                <input
                    id="sellQuantity"
                    type="number"
                    min={1}
                    max={selectedItem.quantity}
                    value={sellQuantity}
                    onChange={(e) => setSellQuantity(Number(e.target.value))}
                    style={{ width: "90%", padding: "10px" }}
                />
                </div>
            )}

            {/* Price Input */}
            <div style={{ marginBottom: "10px" }}>
                <label htmlFor="sellPrice" style={{ fontWeight: "bold", display: "block" }}>
                Sold Price
                </label>
                <input
                id="sellPrice"
                type="number"
                min={0}
                value={sellPrice}
                onChange={(e) => setSellPrice(e.target.value)}
                style={{ width: "90%", padding: "10px" }}
                />
            </div>

            <div style={{ marginBottom: "10px" }}>
                <label htmlFor="notes" style={{ fontWeight: "bold", display: "block" }}>
                Notes (optional)
                </label>
                <input
                id="notes"
                type="text"
                min={0}
                value={sellNotes}
                onChange={(e) => setsellNotes(e.target.value)}
                style={{ width: "90%", padding: "10px" }}
                />
            </div>

            {/* Links to websites */}
            
            <div style={{ marginBottom: "10px"}}>
                {selectedItem.kijiji !== "" ? <a href={selectedItem.kijiji} target="_blank" rel="noopener noreferrer">
                    <img src="https://images.seeklogo.com/logo-png/32/2/kijiji-logo-png_seeklogo-324465.png" alt="Kijiji" style={{width: "75px", height: '75px'}}/>
                </a> : <div></div>}
                {selectedItem.ebay !== "" ? <a href={selectedItem.ebay} target="_blank" rel="noopener noreferrer">
                    <img src="https://tse2.mm.bing.net/th/id/OIP.S9o0bxtfmE_2Hr-_XXdmowHaHa?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3" alt="Kijiji" style={{width: "75px", height: '75px'}}/>
                </a> : <div></div>}
                {selectedItem.link !== "" ? <a href={selectedItem.link} target="_blank" rel="noopener noreferrer">
                    <img src="https://static.vecteezy.com/system/resources/previews/019/787/073/non_2x/link-flat-on-transparent-background-free-png.png" alt="Kijiji" style={{width: "75px", height: '50px'}}/>
                </a> : <div></div>}
            </div>

            {/* Buttons */}
            <div style={{ display: "flex", gap: "10px" }}>
                <button
                onClick={handleSell}
                style={{ flex: 1 }}
                >
                Sell
                </button>
                <button
                onClick={() => {
                    navigate("/edit", { state: { item: selectedItem } });
                }}
                style={{ flex: 1, backgroundColor: "#f39c12" }}
                >
                Edit
                </button>
            </div>
            </div>
        </div>
        )}
    </div>
  );
}

export default Search;
